import { render, staticRenderFns } from "./CompanyContractorProvider.vue?vue&type=template&id=1c7dcba5"
import script from "./CompanyContractorProvider.vue?vue&type=script&lang=ts"
export * from "./CompanyContractorProvider.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c7dcba5')) {
      api.createRecord('1c7dcba5', component.options)
    } else {
      api.reload('1c7dcba5', component.options)
    }
    module.hot.accept("./CompanyContractorProvider.vue?vue&type=template&id=1c7dcba5", function () {
      api.rerender('1c7dcba5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/companyContractors/CompanyContractorProvider.vue"
export default component.exports